<template>
  <v-card class="card-border">
    <v-card-title>
      Erros na Geração dos Materiais
    </v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="items"> </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TabelaErrosMateriais",

  props: {
    erros: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      headers: [
        { text: "Colaborador", value: "nome" },
        { text: "Erro", value: "erro" }
      ]
    };
  },

  computed: {
    items() {
      return this.erros;
    }
  }
};
</script>
